<script setup>

</script>

<template>
  <div class="copyright">
    <p>以上服务由全积分公司提供技术支持</p>
    <p>服务热线：400-0360-195</p>
  </div>
</template>

<style scoped lang="less">

</style>
